import type { Translations } from './de';

export const en = {
  appName: 'Sudoku',
  tagline: 'Clear. Calm. Completely yours.',
  settings: 'Settings',
  language: 'Language',
  german: 'German',
  english: 'English',
  theme: 'Colour theme',
  lightTheme: 'Light',
  darkTheme: 'Dark',
  foundationTitle: 'Ready for the game',
  foundationMessage:
    'The technical foundation is in place. The playable Sudoku area comes in the next step.',
  localTitle: 'Local',
  localDescription: 'Your game and settings stay in this browser.',
  accessibleTitle: 'Accessible',
  accessibleDescription: 'Prepared for keyboard, mouse, touch and assistive technology.',
  responsiveTitle: 'Flexible',
  responsiveDescription: 'Designed for phone, tablet and computer.',
  milestone: 'Project foundation',
  gameTitle: 'Your Sudoku',
  boardLabel: 'Sudoku board',
  pausedBoard: 'Board hidden while paused',
  fixedCell: 'fixed',
  editableCell: 'editable',
  emptyCell: 'empty',
  cellValue: 'value',
  cellCandidates: 'candidates',
  conflictCell: 'conflict',
  incorrectCell: 'incorrect value',
  row: 'Row',
  column: 'column',
  easy: 'Easy',
  medium: 'Medium',
  hard: 'Hard',
  difficulty: 'Difficulty',
  newGame: 'New game',
  generating: 'Creating Sudoku …',
  generationFailed: 'The Sudoku could not be created.',
  tryAgain: 'Try again',
  timer: 'Game time',
  pause: 'Pause',
  resume: 'Resume',
  paused: 'Game paused',
  undo: 'Undo',
  redo: 'Redo',
  erase: 'Erase',
  notes: 'Notes',
  numberPad: 'Number input',
  gameActions: 'Game actions',
  restart: 'Restart',
  completed: 'Well done! You solved the Sudoku.',
  failedGame: 'Game failed. You reached three mistakes.',
  mistakes: 'Mistakes',
  mistakeStatus: 'Mistake count',
  selected: 'selected',
  cancel: 'Cancel',
  confirmRestartTitle: 'Restart game?',
  confirmRestartMessage: 'All entries and notes in this Sudoku will be lost.',
  confirmRestartAction: 'Restart game',
  confirmNewGameTitle: 'Start a new game?',
  confirmNewGameMessage: 'All entries and notes in the current Sudoku will be lost.',
  confirmNewGameAction: 'Start new game',
} as const satisfies Translations;
